import * as JsSIP from 'jssip';
var CCLog = {
    info: console.info,
    error: console.error,
    warn: console.warn
};
export var WebRTCSupport = {
    localMedia: false,
    recording: false,
    remoteStreamProcessing: false,
    check: function () {
        window['AudioContext'] = window['AudioContext'] || window['webkitAudioContext'];
        navigator.getUserMedia =
            navigator.getUserMedia || navigator['webkitGetUserMedia'] || navigator['mozGetUserMedia'];
        var isChrome = !!window['chrome'] && !!window['chrome'].webstore;
        this.remoteStreamProcessing = !isChrome;
        this.recording = typeof MediaRecorder !== 'undefined';
        this.localMedia = !!navigator.getUserMedia;
        CCLog.info('WebRTCSupport: ' + JSON.stringify(this));
    }
};
window['WebRTCSupport'] = WebRTCSupport;
export var WebRTCAudio = {
    stream: { local: undefined, remote: undefined },
    remoteAudioElem: undefined,
    speaker: { sourceNode: undefined, gainNode: undefined },
    mic: { sourceNode: undefined, gainNode: undefined, convolverNode: undefined },
    audioContext: undefined,
    destination: {
        speakers: undefined,
        peerConnection: undefined,
        recording: undefined
    },
    init: function (remoteAudioElemId) {
        CCLog.info('WebRTCAudio Initializing');
        try {
            this.audioContext = new AudioContext();
            this.destination.speakers = this.audioContext.destination;
            this.destination.peerConnection = this.audioContext.createMediaStreamDestination();
            this.destination.recording = this.audioContext.createMediaStreamDestination();
            this.mic.convolverNode = this.audioContext.createConvolver();
            this.mic.gainNode = this.audioContext.createGain();
            this.remoteAudioElem = document.getElementById(remoteAudioElemId);
            this.speaker.gainNode = this.audioContext.createGain();
            this.speaker.sourceNode = this.audioContext.createMediaElementSource(this.remoteAudioElem);
            this.speaker.sourceNode.connect(this.speaker.gainNode);
            this.speaker.gainNode.connect(this.destination.recording);
            this.speaker.gainNode.connect(this.destination.speakers);
            if (WebRTCSupport.recording)
                WebRTCRecorder.init(this.destination.recording.stream);
        }
        catch (e) {
            // SIPClientError.notify('WebRTCAudio Web Audio API not supported.');
            CCLog.error('WebRTCAudio Web Audio API not supported.');
        }
    },
    addRemoteStream: function (stream) {
        this.stream.remote = stream;
        this.remoteAudioElem.srcObject = stream;
    },
    clearRemoteStream: function () {
        this.stream.remote = undefined;
    },
    loadLocalStream: function (onAfterSuccess, onError) {
        navigator.getUserMedia({ audio: true, video: false }, function (stream) {
            WebRTCAudio.stream.local = WebRTCAudio.applyStreamPreprocessing(stream);
            onAfterSuccess(WebRTCAudio.stream.local);
        }, onError);
    },
    applyStreamPreprocessing: function (stream) {
        this.mic.sourceNode = this.audioContext.createMediaStreamSource(stream);
        this.mic.sourceNode.connect(this.mic.gainNode);
        this.mic.gainNode.connect(this.destination.peerConnection);
        this.mic.gainNode.connect(this.destination.recording);
        return this.destination.peerConnection.stream;
    },
    convolverOn: function (active) {
        if (active) {
            this.mic.sourceNode.disconnect();
            this.mic.sourceNode.connect(this.mic.convolverNode);
            this.mic.convolverNode.connect(this.mic.gainNode);
        }
        else {
            this.mic.convolverNode.disconnect();
            this.mic.sourceNode.disconnect();
            this.mic.sourceNode.connect(this.mic.gainNode);
        }
    }
};
window['WebRTCAudio'] = WebRTCAudio;
export var WebRTC = {
    userAgent: undefined,
    session: undefined,
    request: undefined,
    normalVolumeLevel: 50,
    uaConfig: undefined,
    dtmfOptions: undefined,
    handleFinished: false,
    handleAnswered: false,
    registered: false,
    endpoints: { type: 'POST', hangup: '/call-panel/action/hangup', init: '/call-panel/action/init' },
    events: {
        onAfterInit: undefined,
        registrationFailed: undefined,
        unregistered: undefined,
        ended: undefined,
        failed: undefined
    },
    incomingSessionOptions: {
        mediaConstraints: {
            audio: true,
            video: false
        },
        RTCOfferConstraints: { mandatory: { OfferToReceiveAudio: true } }
    },
    loadConfig: function (config) {
        if (config.pcConfig) {
            this.incomingSessionOptions.pcConfig = config.pcConfig;
            CCLog.info('WebRTC pcConfig: ' + JSON.stringify(config.pcConfig));
        }
        if (config.debug)
            JsSIP.debug.enable('*');
        if (config.webrtc)
            this.uaConfig = config.webrtc;
        this.dtmfOptions = config.dtmfOptions;
        if (config.recordingType && WebRTCRecorder)
            WebRTCRecorder.defaultRecordingType = config.recordingType;
    },
    startAgent: function (localStream) {
        WebRTC.incomingSessionOptions['mediaStream'] = localStream;
        CCLog.info('WebRTC Init JsSIP.UA: ' + WebRTC.uaConfig.uri);
        WebRTC.userAgent = new JsSIP.UA(WebRTC.uaConfig);
        WebRTC.initEvents();
        WebRTC.userAgent.start();
    },
    init: function (config, onAfterInit) {
        CCLog.info('WebRTC Initializing');
        this.events.onAfterInit = onAfterInit;
        WebRTCSupport.check();
        WebRTCAudio.init('remote-stream-audio');
        // // if (WebRTCSupport.localMedia && !SIPClientError.hasErrors()) {
        if (WebRTCSupport.localMedia) {
            this.loadConfig(config);
            WebRTCAudio.loadLocalStream(this.startAgent, function (err) {
                // // SIPClientError.notify("WebRTC Error when loading getUserMedia: " + err.name);
                CCLog.error('WebRTC Error when loading getUserMedia: ' + err.name);
            });
        }
        else {
            // // SIPClientError.notify("WebRTC getUserMedia not supported");
            CCLog.error('WebRTC getUserMedia not supported');
        }
    },
    hangup: function () {
        CCLog.info('WebRTC Session hangup');
        if (WebRTC.session) {
            WebRTC.session.terminate();
            return true;
        }
        else {
            CCLog.warn('WebRTC No session - cannot hangup');
            return false;
        }
    },
    onRegistered: function (e) {
        CCLog.info('WebRTC websocket onRegistered: ' + WebRTC.registered);
        if (WebRTC.registered) {
            CCLog.info('WebRTC was already registered');
            return;
        }
        WebRTC.registered = true;
        if (typeof WebRTC.events.onAfterInit === 'function')
            WebRTC.events.onAfterInit();
    },
    onUnregistered: function (e) {
        CCLog.warn('WebRTC ua has been unregistered periodic registration fails or ua.unregister(). Cause: ', e.cause);
        if (typeof WebRTC.events.unregistered === 'function')
            WebRTC.events.unregistered(e.cause);
        // SIPClientError.notify("Session failed: " + e.cause);
    },
    toneDialing: function (tone) {
        if (this.session) {
            console.info('WebRTC Tone dial: ' + tone);
            this.session.sendDTMF(tone, this.dtmfOptions);
        }
    },
    setVolumeMic: function (volume) {
        WebRTCAudio.mic.gainNode.gain.value = volume / WebRTC.normalVolumeLevel;
        console.info('Mic vol: ' + WebRTCAudio.mic.gainNode.gain.value);
    },
    getVolumeMic: function () {
        return WebRTCAudio.mic.gainNode.gain.value * WebRTC.normalVolumeLevel;
    },
    setVolumeSpeaker: function (volume) {
        WebRTCAudio.remoteAudioElem.volume = volume / 100;
        WebRTCAudio.speaker.gainNode.gain.value = volume / WebRTC.normalVolumeLevel;
        console.info('Speaker vol: ' + WebRTCAudio.speaker.gainNode.gain.value);
    },
    getVolumeSpeaker: function () {
        return WebRTCAudio.remoteAudioElem.volume * 100;
    },
    onNewRTCSession: function (e) {
        CCLog.info('WebRTC new rtc session created: ' + e.originator);
        WebRTC.session = e.session;
        if (WebRTC.session.isMuted()['audio']) {
            CCLog.info('WebRTC Session is muted!!! Need to change state of muted checkbox?');
        }
        if (e.originator == 'remote') {
            WebRTC.handleIncomingSession(e.session);
        }
    },
    handleIncomingSession: function (incomingSession) {
        incomingSession.on('addstream', function (e) {
            CCLog.info('WebRTC.on addstream');
            WebRTCAudio.addRemoteStream(e.stream);
        });
        incomingSession.on('peerconnection', function (e) {
            CCLog.info('WebRTC.on peerconnection');
        });
        incomingSession.on('connecting', function (e) {
            CCLog.info('WebRTC.on connecting');
        });
        incomingSession.on('sending', function (e) {
            CCLog.info('WebRTC.on sending');
        });
        incomingSession.on('progress', function (e) {
            CCLog.info('WebRTC.on progress: ', e.originator);
        });
        incomingSession.on('accepted', function (e) {
            CCLog.info('WebRTC.on accepted: ', e.originator);
        });
        incomingSession.on('confirmed', function (e) {
            CCLog.info('WebRTC.on confirmed: ', e.originator);
        });
        incomingSession.on('ended', function (e) {
            CCLog.info('WebRTC.on ended. Cause: ' + e.cause + ', ' + e.originator);
            WebRTC.session = undefined;
            if (typeof WebRTC.events.ended === 'function')
                WebRTC.events.ended(e.cause);
            WebRTCAudio.clearRemoteStream();
        });
        incomingSession.on('failed', function (e) {
            CCLog.error('WebRTC.on failed. Cause: ' + e.cause + ', ' + e.originator);
            if (e.cause === 'WebRTC Error') {
                // SIPClientError.connectionProblems();
                return;
            }
            if (typeof WebRTC.events.failed === 'function')
                WebRTC.events.failed(e.cause);
            // SIPClientError.notify("Session failed: " + e.cause);
        });
        incomingSession.on('removestream', function (e) {
            CCLog.info('WebRTC.on removestream');
            WebRTCAudio.clearRemoteStream();
        });
        CCLog.info('WebRTC Answering call');
        incomingSession.answer(this.incomingSessionOptions);
    },
    initEvents: function () {
        this.userAgent.on('registrationFailed', function (e) {
            // SIPClientError.notify("WebRTC registrationFailed failed: " + e.cause);
            CCLog.error('WebRTC registrationFailed failed: ', e.cause);
            if (typeof WebRTC.events.registrationFailed === 'function')
                WebRTC.events.registrationFailed(e.cause);
        });
        this.userAgent.on('connected', function (e) {
            CCLog.info('WebRTC connected to websocket');
        });
        this.userAgent.on('disconnected', function (e) {
            // Sometimes e is undefined, sentry error
            if (!e) {
                e = {};
            }
            if (e.code === 1000) {
                CCLog.info('WebRTC websocket normally disconnected');
                return;
            }
            // SIPClientError.notify("WebRTC websocket disconnected: " + e.reason);
            CCLog.error('WebRTC websocket disconnected: ' + e.reason + ' code: ' + e.code);
            WebRTC.userAgent.start();
        });
        this.userAgent.on('registered', this.onRegistered);
        this.userAgent.on('unregistered', this.onUnregistered);
        this.userAgent.on('newRTCSession', this.onNewRTCSession);
        this.userAgent.on('newMessage', function (e) {
            CCLog.info('MESSAGE request. Origin: ' + e.originator);
        });
    },
    startTestCall: function (afterTestFinish) {
        CCLog.warn('WebRTC startTestCall. test call not implemented for WebRTC. Immediately starting calls');
        afterTestFinish();
    },
    disconnect: function () {
        this.userAgent.stop();
    }
};
window['WebRTC'] = WebRTC;
export var WebRTCRecorder = {
    mediaRecorder: undefined,
    chunks: [],
    fileName: undefined,
    defaultRecordingType: 'audio/ogg; codecs=opus',
    start: function (recordingName) {
        if (!this.mediaRecorder) {
            CCLog.error('WebRTCRecorder No mediarecorder defined');
            return;
        }
        CCLog.info('WebRTCRecorder Starting recording: ' + recordingName);
        this.chunks = [];
        this.fileName = recordingName;
        this.mediaRecorder.start();
    },
    stop: function () {
        if (!this.mediaRecorder) {
            CCLog.error('WebRTCRecorder No mediarecorder defined');
            return;
        }
        CCLog.info('WebRTCRecorder Stopping recording: ' + this.fileName);
        this.mediaRecorder.stop();
    },
    init: function (stream) {
        CCLog.info('WebRTCRecorder Initializing');
        var self = this;
        this.mediaRecorder = new MediaRecorder(stream);
        this.mediaRecorder.onstop = function (e) {
            CCLog.info('WebRTCRecorder Saving recording: ' + self.fileName);
            var blob = new Blob(self.chunks, { type: self.defaultRecordingType });
            this.saveAs(blob, self.fileName);
            self.chunks = [];
            self.fileName = undefined;
        };
        this.mediaRecorder.ondataavailable = function (e) {
            self.chunks.push(e.data);
        };
        this.mediaRecorder.onerror = function (e) {
            CCLog.error('WebRTCRecorder MediaRecorder error', e);
        };
    }
};
window['WebRTCRecorder'] = WebRTCRecorder;
//# sourceMappingURL=webrtc.js.map